<!-- dialog view -->
<h2 mat-dialog-title class="modals-view__title">{{ dataModule.name }}</h2>
<mat-dialog-content class="mat-typography">
  @if (dataModule.content_type === 'application/pdf') {
    <iframe [src]="pdfData" style="width: 100%;height: 100vh;border: 0px solid #000;"></iframe>
  }
  @if (dataModule.content_type !== 'application/pdf') {
    <img [src]="dataModule.decrypted_file" alt="{{dataModule.name}}" class="modals-view__image"/>
  }
</mat-dialog-content>
<mat-dialog-actions class="modals-view__actions">
  <button type="button" class="xr-btn xr-btn--secondary" mat-dialog-close>{{ 'technicians_page.close' | translate }}</button>
  @if (dataModule.download) {
    <button type="button" class="xr-btn xr-btn--primary" (click)="dataModule.download()">{{ 'technicians_page.qr_download' | translate }}</button>
  }
</mat-dialog-actions>
